import swal from 'sweetalert2';
import './swal/swal.css';

const Toast = swal.mixin({
    customClass: {
        container: 'my-swal-container-toast'
    },
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', swal.stopTimer)
        toast.addEventListener('mouseleave', swal.resumeTimer);
    }
})

const mySwal = {
    prompt: (message, defaultValue) => swal.fire({
        customClass: {
            container: 'my-swal-container my-swal-container-left'
        },
        title: message,
        input: 'text',
        inputPlaceholder: defaultValue || '',
        confirmButtonText: '确定',
        confirmButtonColor: 'hsla(92, 38%, 46%, 1)',
    }),
    error: (text, title) => swal.fire({
        customClass: {
            container: 'my-swal-container my-swal-container-left my-swal-container-icon',
            title: 'swal-title swal-title-error'
        },
        title: title || '错误',
        text: text,
        type: '',
        confirmButtonText: '确定',
        confirmButtonColor: 'hsla(92, 38%, 46%, 1)'
    }),
    info: (text, title) => swal.fire({
        customClass: {
            container: 'my-swal-container my-swal-container-left my-swal-container-icon',
            title: 'swal-title swal-title-info'
        },
        title: title || '提示',
        text: text,
        type: '',
        confirmButtonText: '确定',
        confirmButtonColor: 'hsla(92, 38%, 46%, 1)'
    }),
    warning: (text, title) => swal.fire({
        customClass: {
            container: 'my-swal-container my-swal-container-left my-swal-container-icon',
            title: 'swal-title swal-title-warning'
        },
        title: title || '警告',
        text: text,
        type: '',
        confirmButtonText: '确定',
        confirmButtonColor: 'hsla(92, 38%, 46%, 1)'
    }),
    succ: (text, title) => swal.fire({
        customClass: {
            container: 'my-swal-container my-swal-container-left my-swal-container-icon',
            title: 'swal-title swal-title-success'
        },
        icon: '',
        title: title || '提示',
        text,
        confirmButtonText: '确定',
        confirmButtonColor: 'hsla(92, 38%, 46%, 1)'
    }),
    swal: (...args) => swal.fire(...args),
    noAccess () {
        this.error('您无此操作权限，请咨询小猴编程老师！');
    },
    swalAgent (
        err,
        defaultText,
        options
    ) {
        // if (
        //     typeof err === 'object' &&
        //     err.status === 401
        // ) {
        //     this.error('请重新登录！');
        //     return;
        // }

        const {
            data = {}, message, statusText, status, response
        } = err || {};

        let responseCode = '';
        let responseMessage = '';

        if (response && response.data) {
            responseCode = response.data.status || ''
            responseMessage = response.data.message || ''
        }

        const msg = responseMessage || message || data.message || statusText || '';
        const msgCode = responseCode || status || '';

        if (msgCode === 401) {
            this.error('token已失效，请重新登录！');
            return;
        }

        let msgs = defaultText ? defaultText : '';
        if (msgCode) msgs += ` 错误码：${msgCode}`;
        if (msg) msgs += ` 错误信息：${msg}`;
        return swal.fire({
            customClass: {
                container: 'my-swal-container my-swal-container-left my-swal-container-icon',
                title: 'swal-title swal-title-error'
            },
            icon: '',
            text: msgs,
            title: '错误提醒',
            confirmButtonText: '确定',
            confirmButtonColor: 'hsla(92, 38%, 46%, 1)',
            ...options
        });
    },
    confirm: (title, text) => swal.fire({
        customClass: {
            container: 'my-swal-container my-swal-container-left my-swal-container-icon',
            title: 'swal-title swal-title-warning'
        },
        icon: '',
        title: title || '信息确认',
        text,
        showCancelButton: true,
        confirmButtonColor: 'hsla(92, 38%, 46%, 1)',
        cancelButtonColor: '#fff',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        reverseButtons: true
    }),
    toast: (title, type) => Toast.fire({
        icon: type || 'info',
        title: title || ''
    })
};
window.swal = mySwal;
export default mySwal;
